import { useEffect, useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

import { DASHBOARD_TAB_VALUES, DEFAULT_DASHBOARD_TAB } from '../constants';

const normalizeDashboardTab = (tab) =>
  DASHBOARD_TAB_VALUES.has(tab) ? tab : DEFAULT_DASHBOARD_TAB;

const useDashboardTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const activeTab = useMemo(() => normalizeDashboardTab(tabParam), [tabParam]);

  useEffect(() => {
    if (!tabParam || DASHBOARD_TAB_VALUES.has(tabParam)) return;

    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete('tab');
    setSearchParams(nextParams, { replace: true });
  }, [searchParams, setSearchParams, tabParam]);

  const setActiveTab = (nextTab) => {
    const normalizedTab = normalizeDashboardTab(nextTab);
    const nextParams = new URLSearchParams(searchParams);

    if (normalizedTab === DEFAULT_DASHBOARD_TAB) {
      nextParams.delete('tab');
    } else {
      nextParams.set('tab', normalizedTab);
    }

    setSearchParams(nextParams);
  };

  return {
    activeTab,
    setActiveTab,
  };
};

export default useDashboardTabs;
